module.exports = __webpack_public_path__ + "assets/fbbb98fbf75a6d0007c3453ff0f8f70f.mp3";